import { useNavigate, useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Header, ModifierGroup, Severity } from "../types";
import {
  useFetchItemDetailsQuery,
  useUpdateItemImageMutation,
  useUpdateItemMutation,
} from "../store";
import { itemSchema } from "../configs";
import { showToast, ToastType } from "../utils/toast.utils";
import ItemForm from "../forms/item.form";
import ImageUploader from "../components/common/UploadImage";

const EditItemWrapper = () => {
  const { itemId } = useParams();

  if (!itemId)
    return (
      <InfoChip severity={Severity.DANGER} content="Article introuvable" />
    );

  return <EditItem itemId={itemId} />;
};

interface EditItemProps {
  itemId: string;
}

const EditItem: React.FC<EditItemProps> = ({ itemId }) => {
  const [updateItem, { isLoading }] = useUpdateItemMutation();
  const [updateItemImage] = useUpdateItemImageMutation();
  const { data: itemDetails, isFetching } = useFetchItemDetailsQuery(itemId);
  const navigate = useNavigate();

  if (isLoading || isFetching) return <div>Loading...</div>;

  if (!itemDetails)
    return (
      <InfoChip severity={Severity.DANGER} content="Produit introuvable" />
    );

  const handleUploadImage = async (file: File) => {
    const result = await updateItemImage({ itemId, file });
    if (!result.error) {
      showToast("Image mise à jour", ToastType.SUCCESS);
    }
  };

  console.log("itemDetails.imagePath :", itemDetails.imagePath);
  return (
    <div className="w-full flex flex-col items-center p-4">
      <div className="w-3/5 flex justify-evenly gap-6">
        <ImageUploader
          imgUrl={itemDetails.imagePath}
          onUpload={handleUploadImage}
          label="Changer l'image"
          showAction
        />
      </div>
      <ItemForm
        initialValues={itemDetails}
        validationSchema={itemSchema}
        restaurantId={itemDetails.restaurant}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const formattedValues = {
            ...values,
            headers: values.headers.map((h: Header) => h._id),
            modifierGroups: values.modifierGroups.map(
              (mg: ModifierGroup) => mg._id
            ),
          };

          const result = await updateItem({
            itemId,
            body: formattedValues,
          });
          if (!result.error) {
            showToast("Produit mis à jour", ToastType.SUCCESS);
            resetForm();
            navigate("/items");
          }
        }}
      />
    </div>
  );
};

export default EditItemWrapper;
